module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA50lEQVQ4T+3TvU0DQRQE4Jn0ZFMAAUVACb7bgEUiowL/ZMRQAcRkCCogO8AO9q07sOjBiQsw1iUXDLqTAMkSsg5v6InffsG+eUTisPHM7ETSK8n+f3xJn3VdX3rvly0YQhiQjADWADYd0R6AI0m5c26+Dd4WRXHfBTSzGwB3B/BnKYc/3F2gv2pzTnIK4EXS+27md4LkBYArSd45N2uLHWN8kjTsAm3PknzO83zEsiz7WZatADQntE82VVUdM8Y4lvS4j/T9luSEIYQFybMUIIAFzewNwGki8KMBPYCHROB1u+WUSQ5+AZykryuId8DLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/middle_five.png
// module id = CRik
// module chunks = 1